import script from "./CSR00200.vue?vue&type=script&setup=true&lang=ts"
export * from "./CSR00200.vue?vue&type=script&setup=true&lang=ts"

import "./CSR00200.vue?vue&type=style&index=0&id=cc8215e8&scoped=true&lang=css"
import "./CSR00200.vue?vue&type=style&index=1&id=cc8215e8&lang=css"

import exportComponent from "C:\\atto\\atto-chempanda\\chempanda\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cc8215e8"]])

export default __exports__
import QBtnToggle from 'quasar/src/components/btn-toggle/QBtnToggle.js';
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtnGroup from 'quasar/src/components/btn-group/QBtnGroup.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtnToggle,QExpansionItem,QBtn,QIcon,QBtnGroup});
